// @flow
const ADD_CUSTOM_XMP_NAMESPACES = 'admin/catalog/ADD_CUSTOM_XMP_NAMESPACES';
const ADD_CUSTOM_XMP_NAMESPACES_FAIL =
  'admin/catalog/ADD_CUSTOM_XMP_NAMESPACES_FAIL';
const ADD_CUSTOM_XMP_NAMESPACES_SUCCESS =
  'admin/catalog/ADD_CUSTOM_XMP_NAMESPACES_SUCCESS';
const ADD_FIELDS = 'admin/catalog/ADD_FIELDS';
const ADD_FIELDS_FAIL = 'admin/catalog/ADD_FIELDS_FAIL';
const ADD_FIELDS_SUCCESS = 'admin/catalog/ADD_FIELDS_SUCCESS';
const ADD_NESTED_VALUES = 'admin/catalog/ADD_NESTED_VALUES';
const ADD_NESTED_VALUES_SUCCESS = 'admin/catalog/ADD_NESTED_VALUES_SUCCESS';
const ADD_NESTED_VALUES_FAIL = 'admin/catalog/ADD_NESTED_VALUES_FAIL';
const ADD_OR_UPDATE_USER_CATALOG_INFO =
  'admin/catalog/ADD_OR_UPDATE_USER_CATALOG_INFO';
const ADD_OR_UPDATE_USER_CATALOG_INFO_FAIL =
  'admin/catalog/ADD_OR_UPDATE_USER_CATALOG_INFO_FAIL';
const ADD_OR_UPDATE_USER_CATALOG_INFO_SUCCESS =
  'admin/catalog/ADD_OR_UPDATE_USER_CATALOG_INFO_SUCCESS';
const CREATE_CATALOG = 'admin/catalog/CREATE_CATALOG';
const CREATE_CATALOG_FAIL = 'admin/catalog/CREATE_CATALOG_FAIL';
const CREATE_CATALOG_SUCCESS = 'admin/catalog/CREATE_CATALOG_SUCCESS';
const CREATE_CATALOG_TEMPLATE = 'admin/catalog/CREATE_CATALOG_TEMPLATE';
const CREATE_CATALOG_TEMPLATE_FAIL =
  'admin/catalog/CREATE_CATALOG_TEMPLATE_FAIL';
const CREATE_CATALOG_TEMPLATE_SUCCESS =
  'admin/catalog/CREATE_CATALOG_TEMPLATE_SUCCESS';
const CREATE_METADATA_DEFINITIONS = 'admin/catalog/CREATE_METADATA_DEFINITIONS';
const CREATE_METADATA_DEFINITIONS_FAIL =
  'admin/catalog/CREATE_METADATA_DEFINITIONS_FAIL';
const CREATE_METADATA_DEFINITIONS_SUCCESS =
  'admin/catalog/CREATE_METADATA_DEFINITIONS_SUCCESS';
const CREATE_METADATA_MAPPINGS = 'admin/catalog/CREATE_METADATA_MAPPINGS';
const CREATE_METADATA_MAPPINGS_FAIL =
  'admin/catalog/CREATE_METADATA_MAPPINGS_FAIL';
const CREATE_METADATA_MAPPINGS_SUCCESS =
  'admin/catalog/CREATE_METADATA_MAPPINGS_SUCCESS';
const DELETE_CATALOG = 'admin/catalog/DELETE_CATALOG';
const DELETE_CATALOG_FAIL = 'admin/catalog/DELETE_CATALOG_FAIL';
const DELETE_CATALOG_SUCCESS = 'admin/catalog/DELETE_CATALOG_SUCCESS';
const DELETE_CATALOG_TEMPLATE = 'admin/catalog/DELETE_CATALOG_TEMPLATE';
const DELETE_CATALOG_TEMPLATE_FAIL =
  'admin/catalog/DELETE_CATALOG_TEMPLATE_FAIL';
const DELETE_CATALOG_TEMPLATE_SUCCESS =
  'admin/catalog/DELETE_CATALOG_TEMPLATE_SUCCESS';
const DELETE_METADATA_DEFINITION = 'admin/catalog/DELETE_METADATA_DEFINITION';
const DELETE_METADATA_DEFINITION_FAIL =
  'admin/catalog/DELETE_METADATA_DEFINITION_FAIL';
const DELETE_METADATA_DEFINITION_SUCCESS =
  'admin/catalog/DELETE_METADATA_DEFINITION_SUCCESS';
const DELETE_METADATA_MAPPINGS = 'admin/catalog/DELETE_METADATA_MAPPINGS';
const DELETE_METADATA_MAPPINGS_FAIL =
  'admin/catalog/DELETE_METADATA_MAPPINGS_FAIL';
const DELETE_METADATA_MAPPINGS_SUCCESS =
  'admin/catalog/DELETE_METADATA_MAPPINGS_SUCCESS';
const DELETE_NESTED_VALUES = 'admin/catalog/DELETE_NESTED_VALUES';
const DELETE_NESTED_VALUES_SUCCESS =
  'admin/catalog/DELETE_NESTED_VALUES_SUCCESS';
const DELETE_NESTED_VALUES_FAIL = 'admin/catalog/DELETE_NESTED_VALUES_FAIL';
const GET_CATALOGS = 'admin/catalog/GET_CATALOGS';
const GET_CATALOGS_FAIL = 'admin/catalog/GET_CATALOGS_FAIL';
const GET_CATALOGS_SUCCESS = 'admin/catalog/GET_CATALOGS_SUCCESS';
const GET_CATALOG_PROPERTIES = 'admin/catalog/GET_CATALOG_PROPERTIES';
const GET_CATALOG_PROPERTIES_FAIL = 'admin/catalog/GET_CATALOG_PROPERTIES_FAIL';
const GET_CATALOG_PROPERTIES_SUCCESS =
  'admin/catalog/GET_CATALOG_PROPERTIES_SUCCESS';
const GET_CATALOG_TYPES = 'admin/catalog/GET_CATALOG_TYPES';
const GET_CATALOG_TYPES_FAIL = 'admin/catalog/GET_CATALOG_TYPES_FAIL';
const GET_CATALOG_TYPES_SUCCESS = 'admin/catalog/GET_CATALOG_TYPES_SUCCESS';
const GET_CUSTOM_XMP_NAMESPACES = 'admin/catalog/GET_CUSTOM_XMP_NAMESPACES';
const GET_CUSTOM_XMP_NAMESPACES_FAIL =
  'admin/catalog/GET_CUSTOM_XMP_NAMESPACES_FAIL';
const GET_CUSTOM_XMP_NAMESPACES_SUCCESS =
  'admin/catalog/GET_CUSTOM_XMP_NAMESPACES_SUCCESS';
const GET_FIELDS = 'admin/catalog/GET_FIELDS';
const GET_FIELDS_FAIL = 'admin/catalog/GET_FIELDS_FAIL';
const GET_FIELDS_SUCCESS = 'admin/catalog/GET_FIELDS_SUCCESS';
const GET_METADATA = 'admin/catalog/GET_METADATA';
const GET_METADATA_FAIL = 'admin/catalog/GET_METADATA_FAIL';
const GET_METADATA_SUCCESS = 'admin/catalog/GET_METADATA_SUCCESS';
const GET_METADATA_MAPPINGS = 'admin/catalog/GET_METADATA_MAPPINGS';
const GET_METADATA_MAPPINGS_FAIL = 'admin/catalog/GET_METADATA_MAPPINGS_FAIL';
const GET_METADATA_MAPPINGS_SUCCESS =
  'admin/catalog/GET_METADATA_MAPPINGS_SUCCESS';
const GET_USER_CATALOG_INFO = 'admin/catalog/GET_USER_CATALOG_INFO';
const GET_USER_CATALOG_INFO_FAIL = 'admin/catalog/GET_USER_CATALOG_INFO_FAIL';
const GET_USER_CATALOG_INFO_SUCCESS =
  'admin/catalog/GET_USER_CATALOG_INFO_SUCCESS';
const RENAME_CATALOG = 'admin/catalog/RENAME_CATALOG';
const RENAME_CATALOG_SUCCESS = 'admin/catalog/RENAME_CATALOG_SUCCESS';
const RENAME_CATALOG_FAIL = 'admin/catalog/RENAME_CATALOG_FAIL';
const RENAME_CATALOG_TEMPLATE = 'admin/catalog/RENAME_CATALOG_TEMPLATE';
const RENAME_CATALOG_TEMPLATE_SUCCESS =
  'admin/catalog/RENAME_CATALOG_TEMPLATE_SUCCESS';
const RENAME_CATALOG_TEMPLATE_FAIL =
  'admin/catalog/RENAME_CATALOG_TEMPLATE_FAIL';
const REMOVE_ALL_PREDEFINED_VALUES =
  'admin/catalog/REMOVE_ALL_PREDEFINED_VALUES';
const REMOVE_ALL_PREDEFINED_VALUES_FAIL =
  'admin/catalog/REMOVE_ALL_PREDEFINED_VALUES_FAIL';
const REMOVE_ALL_PREDEFINED_VALUES_SUCCESS =
  'admin/catalog/REMOVE_ALL_PREDEFINED_VALUES_SUCCESS';
const REMOVE_CUSTOM_XMP_NAMESPACES =
  'admin/catalog/REMOVE_CUSTOM_XMP_NAMESPACES';
const REMOVE_CUSTOM_XMP_NAMESPACES_FAIL =
  'admin/catalog/REMOVE_CUSTOM_XMP_NAMESPACES_FAIL';
const REMOVE_CUSTOM_XMP_NAMESPACES_SUCCESS =
  'admin/catalog/REMOVE_CUSTOM_XMP_NAMESPACES_SUCCESS';
const REMOVE_FIELDS = 'admin/catalog/REMOVE_FIELDS';
const REMOVE_FIELDS_FAIL = 'admin/catalog/REMOVE_FIELDS_FAIL';
const REMOVE_FIELDS_SUCCESS = 'admin/catalog/REMOVE_FIELDS_SUCCESS';
const REMOVE_USERS_FROM_CATALOG = 'admin/catalog/REMOVE_USERS_FROM_CATALOG';
const REMOVE_USERS_FROM_CATALOG_FAIL =
  'admin/catalog/REMOVE_USERS_FROM_CATALOG_FAIL';
const REMOVE_USERS_FROM_CATALOG_SUCCESS =
  'admin/catalog/REMOVE_USERS_FROM_CATALOG_SUCCESS';
const RESTORE_FILE_TYPES_DEFAULT = 'admin/catalog/RESTORE_FILE_TYPES_DEFAULT';
const RESTORE_FILE_TYPES_DEFAULT_SUCCESS =
  'admin/catalog/RESTORE_FILE_TYPES_DEFAULT_SUCCESS';
const RESTORE_FILE_TYPES_DEFAULT_FAIL =
  'admin/catalog/RESTORE_FILE_TYPES_DEFAULT_FAIL';
const SET_EXCLUSION_INFO = 'admin/catalog/SET_EXCLUSION_INFO';
const SET_EXCLUSION_INFO_SUCCESS = 'admin/catalog/SET_EXCLUSION_INFO_SUCCESS';
const SET_EXCLUSION_INFO_FAIL = 'admin/catalog/SET_EXCLUSION_INFO_FAIL';
const SET_INGEST_CONFIG = 'admin/catalog/SET_INGEST_CONFIG';
const SET_INGEST_CONFIG_FAIL = 'admin/catalog/SET_INGEST_CONFIG_FAIL';
const SET_INGEST_CONFIG_SUCCESS = 'admin/catalog/SET_INGEST_CONFIG_SUCCESS';
const SET_SELECTED_FIELD_CATEGORY = 'admin/catalog/SET_SELECTED_FIELD_CATEGORY';
const SET_SELECTED_FIELDS_LIST_ITEM_NAME =
  'admin/catalog/SET_SELECTED_FIELDS_LIST_ITEM_NAME';
const UPDATE_CATALOGING_OPTIONS = 'admin/catalog/UPDATE_CATALOGING_OPTIONS';
const UPDATE_CATALOGING_OPTIONS_FAIL =
  'admin/catalog/UPDATE_CATALOGING_OPTIONS_FAIL';
const UPDATE_CATALOGING_OPTIONS_SUCCESS =
  'admin/catalog/UPDATE_CATALOGING_OPTIONS_SUCCESS';
const UPDATE_DISK_PREVIEW_INFO = 'admin/catalog/UPDATE_DISK_PREVIEW_INFO';
const UPDATE_DISK_PREVIEW_INFO_FAIL =
  'admin/catalog/UPDATE_DISK_PREVIEW_INFO_FAIL';
const UPDATE_DISK_PREVIEW_INFO_SUCCESS =
  'admin/catalog/UPDATE_DISK_PREVIEW_INFO_SUCCESS';
const UPDATE_FIELDS = 'admin/catalog/UPDATE_FIELDS';
const UPDATE_FIELDS_FAIL = 'admin/catalog/UPDATE_FIELDS_FAIL';
const UPDATE_FIELDS_SUCCESS = 'admin/catalog/UPDATE_FIELDS_SUCCESS';
const UPDATE_PREDEFINED_LIST = 'admin/catalog/UPDATE_PREDEFINED_LIST';
const UPDATE_PREDEFINED_LIST_SUCCESS =
  'admin/catalog/UPDATE_PREDEFINED_LIST_SUCCESS';
const UPDATE_PREDEFINED_LIST_FAIL = 'admin/catalog/UPDATE_PREDEFINED_LIST_FAIL';
const UPDATE_SMART_KEYWORDS_SETTINGS =
  'admin/catalog/UPDATE_SMART_KEYWORDS_SETTINGS';
const UPDATE_SMART_KEYWORDS_SETTINGS_FAIL =
  'admin/catalog/UPDATE_SMART_KEYWORDS_SETTINGS_FAIL';
const UPDATE_SMART_KEYWORDS_SETTINGS_SUCCESS =
  'admin/catalog/UPDATE_SMART_KEYWORDS_SETTINGS_SUCCESS';

export {
  ADD_CUSTOM_XMP_NAMESPACES,
  ADD_CUSTOM_XMP_NAMESPACES_FAIL,
  ADD_CUSTOM_XMP_NAMESPACES_SUCCESS,
  ADD_FIELDS,
  ADD_FIELDS_SUCCESS,
  ADD_FIELDS_FAIL,
  ADD_NESTED_VALUES,
  ADD_NESTED_VALUES_FAIL,
  ADD_NESTED_VALUES_SUCCESS,
  ADD_OR_UPDATE_USER_CATALOG_INFO,
  ADD_OR_UPDATE_USER_CATALOG_INFO_FAIL,
  ADD_OR_UPDATE_USER_CATALOG_INFO_SUCCESS,
  CREATE_CATALOG,
  CREATE_CATALOG_FAIL,
  CREATE_CATALOG_SUCCESS,
  CREATE_CATALOG_TEMPLATE,
  CREATE_CATALOG_TEMPLATE_FAIL,
  CREATE_CATALOG_TEMPLATE_SUCCESS,
  CREATE_METADATA_MAPPINGS,
  CREATE_METADATA_MAPPINGS_FAIL,
  CREATE_METADATA_MAPPINGS_SUCCESS,
  CREATE_METADATA_DEFINITIONS,
  CREATE_METADATA_DEFINITIONS_FAIL,
  CREATE_METADATA_DEFINITIONS_SUCCESS,
  DELETE_CATALOG,
  DELETE_CATALOG_FAIL,
  DELETE_CATALOG_SUCCESS,
  DELETE_CATALOG_TEMPLATE,
  DELETE_CATALOG_TEMPLATE_FAIL,
  DELETE_CATALOG_TEMPLATE_SUCCESS,
  DELETE_METADATA_DEFINITION,
  DELETE_METADATA_DEFINITION_FAIL,
  DELETE_METADATA_DEFINITION_SUCCESS,
  DELETE_METADATA_MAPPINGS,
  DELETE_METADATA_MAPPINGS_FAIL,
  DELETE_METADATA_MAPPINGS_SUCCESS,
  DELETE_NESTED_VALUES,
  DELETE_NESTED_VALUES_FAIL,
  DELETE_NESTED_VALUES_SUCCESS,
  GET_CATALOGS,
  GET_CATALOGS_FAIL,
  GET_CATALOGS_SUCCESS,
  GET_CATALOG_PROPERTIES,
  GET_CATALOG_PROPERTIES_FAIL,
  GET_CATALOG_PROPERTIES_SUCCESS,
  GET_CATALOG_TYPES,
  GET_CATALOG_TYPES_FAIL,
  GET_CATALOG_TYPES_SUCCESS,
  GET_CUSTOM_XMP_NAMESPACES,
  GET_CUSTOM_XMP_NAMESPACES_FAIL,
  GET_CUSTOM_XMP_NAMESPACES_SUCCESS,
  GET_USER_CATALOG_INFO,
  GET_USER_CATALOG_INFO_FAIL,
  GET_USER_CATALOG_INFO_SUCCESS,
  GET_FIELDS,
  GET_FIELDS_FAIL,
  GET_FIELDS_SUCCESS,
  GET_METADATA,
  GET_METADATA_FAIL,
  GET_METADATA_SUCCESS,
  GET_METADATA_MAPPINGS,
  GET_METADATA_MAPPINGS_FAIL,
  GET_METADATA_MAPPINGS_SUCCESS,
  REMOVE_ALL_PREDEFINED_VALUES,
  REMOVE_ALL_PREDEFINED_VALUES_FAIL,
  REMOVE_ALL_PREDEFINED_VALUES_SUCCESS,
  REMOVE_CUSTOM_XMP_NAMESPACES,
  REMOVE_CUSTOM_XMP_NAMESPACES_FAIL,
  REMOVE_CUSTOM_XMP_NAMESPACES_SUCCESS,
  REMOVE_FIELDS,
  REMOVE_FIELDS_FAIL,
  REMOVE_FIELDS_SUCCESS,
  REMOVE_USERS_FROM_CATALOG,
  REMOVE_USERS_FROM_CATALOG_FAIL,
  REMOVE_USERS_FROM_CATALOG_SUCCESS,
  RENAME_CATALOG,
  RENAME_CATALOG_SUCCESS,
  RENAME_CATALOG_FAIL,
  RENAME_CATALOG_TEMPLATE,
  RENAME_CATALOG_TEMPLATE_SUCCESS,
  RENAME_CATALOG_TEMPLATE_FAIL,
  RESTORE_FILE_TYPES_DEFAULT,
  RESTORE_FILE_TYPES_DEFAULT_SUCCESS,
  RESTORE_FILE_TYPES_DEFAULT_FAIL,
  SET_EXCLUSION_INFO,
  SET_EXCLUSION_INFO_SUCCESS,
  SET_EXCLUSION_INFO_FAIL,
  SET_INGEST_CONFIG,
  SET_INGEST_CONFIG_FAIL,
  SET_INGEST_CONFIG_SUCCESS,
  SET_SELECTED_FIELD_CATEGORY,
  SET_SELECTED_FIELDS_LIST_ITEM_NAME,
  UPDATE_CATALOGING_OPTIONS,
  UPDATE_CATALOGING_OPTIONS_FAIL,
  UPDATE_CATALOGING_OPTIONS_SUCCESS,
  UPDATE_DISK_PREVIEW_INFO,
  UPDATE_DISK_PREVIEW_INFO_FAIL,
  UPDATE_DISK_PREVIEW_INFO_SUCCESS,
  UPDATE_FIELDS,
  UPDATE_FIELDS_FAIL,
  UPDATE_FIELDS_SUCCESS,
  UPDATE_PREDEFINED_LIST,
  UPDATE_PREDEFINED_LIST_FAIL,
  UPDATE_PREDEFINED_LIST_SUCCESS,
  UPDATE_SMART_KEYWORDS_SETTINGS,
  UPDATE_SMART_KEYWORDS_SETTINGS_FAIL,
  UPDATE_SMART_KEYWORDS_SETTINGS_SUCCESS,
};

export type SmartKeywordEngine = {
  token: string,
};

export type SmartKeywordsEngineSettings = {
  confidenceLevel?: number,
  name: string,
  numKeywords?: number,
};

export type SmartKeywordsSettings = {
  confidenceLevel: number,
  enabled: boolean,
  engines: string[],
  engineSettings?: SmartKeywordsEngineSettings[],
  languages: string[],
  numKeywords: number,
  smartKeywordOnCataloging: boolean,
};

export type Attribute = {
  name: string,
  value: string,
};

export type FileType = {
  enabled: boolean,
  extensions: string[],
  title: string,
};

export type ExclusionInfo = {
  allowAllFileTypes: boolean,
  fileTypes: FileType[],
  pathExclusions: Attribute[],
};

export type CatalogingOptions = {
  keywordsFromPathStyle: number,
  useConstrainedIngest: boolean,
};

export type NestedValue = {
  children: NestedValue[],
  id: string,
  parentId?: string,
  value: string,
};

export type FieldDefinition = {
  defaultValues: string[],
  hasPredefinedValues: boolean,
  id: string,
  isEmbeddable: boolean,
  isExtractable: boolean,
  isHierarchical: boolean,
  isMultivalued: boolean,
  isSearchable: boolean,
  isSortable: boolean,
  isSystem: boolean,
  maxLength?: number,
  nestedPredefinedValues: NestedValue[],
  precision?: number,
  predefinedValues: string[],
  showTime?: boolean,
  systemName: string,
  type: number,
  usePredefinedOnly?: boolean,
};

export type MetadataCategory =
  | 'XMP'
  | 'EXIF'
  | 'IPTC'
  | 'MSOffice'
  | 'Movie'
  | 'GEO'
  | 'General'
  | 'Unknown';

export type MetadataDataType =
  | 'String'
  | 'Number'
  | 'Decimal'
  | 'DateTime'
  | 'URL'
  | 'TextBlock'
  | 'Blob'
  | 'Boolean'
  | 'Structure'
  | 'LangAlt';

export type MultiValueType = 'NotMultiValued' | 'Ordered' | 'Unordered';

export type MetadataDefinition = {
  canEmbed: boolean,
  dataType: MetadataDataType,
  displayName: string,
  displayNames: Attribute[],
  id: string,
  isEditable: boolean,
  multivalueType: MultiValueType,
  parentId: string,
  tag: string,
  type: MetadataCategory,
};

export type MetadataMappingType = 'extract' | 'embed';

export type MetadataMapping = {
  fieldDefId: string,
  metadataDefId: string,
  priority: number,
  type: MetadataMappingType,
};

export type NamespaceDefinition = {
  id: string,
  namespace: string,
  preferredAbbreviation: string,
};

// Represents an item in the fields list
// Backed by either a real FieldDefinition or a MetadataDefinition
export type FieldsListItem = {
  canBeDisabled: boolean,
  fieldDef?: FieldDefinition,
  hasCheckbox: boolean,
  isEnabled: boolean,
  metadataDefinition?: MetadataDefinition,
  name: string,
  internalName: string,
  type: 'fd' | 'md',
};

export type IngestConfigField = {
  fieldDefinition: FieldDefinition,
  required: boolean,
};

export type IngestConfig = {
  fields: IngestConfigField[],
  headerText: string,
};

export type DiskPreviewInfo = {
  audioVideoPreviewsEnabled: boolean,
  enabled: boolean,
  jpegCompression: number,
  limitVideoDurationEnabled: boolean,
  maxDimension: number,
  maxVideoDuration: number,
  maxVideoResolution: number,
  path: string,
};

// This is the type definition. The constant definition lives in util/constants.js
type CatalogStorageType = 'Filesystem' | 'S3' | 'Vault';

export type CatalogDetails = {
  assetCount: string,
  creationDate: string,
  numberOfMembers: string,
  numberOfUsersConnected: string,
  status: string,
  storageType: CatalogStorageType,
};

export type CatalogProperties = {
  catalogDetails?: CatalogDetails,
  catalogingOptions?: CatalogingOptions,
  diskPreviewInfo?: DiskPreviewInfo,
  exclusionInfo?: ExclusionInfo,
  ingestConfig?: IngestConfig,
  smartKeywordsSettings?: SmartKeywordsSettings,
};

export type CatalogType = {
  name: string,
  guid: string,
  description: string,
};

export type Catalog = {
  catalogId: string,
  name: string,
  details?: Attribute[],
};

// Everything needed to create a new catalog
export type CreationCatalog = Catalog & {
  catalogType: string,
  catalogTypeLocale: string,
  collation: string,
  isVersioningEnabled: boolean,
  storageType: CatalogStorageType,
};

export type UserCatalogInfo = {
  accountName: string,
  catalogName: string,
  roleName: string,
  userStatus?: 'online' | 'offline',
};

export type CatalogState = {
  catalogs: Catalog[],
  catalogProperties: CatalogProperties,
  catalogTypes: CatalogType[],
  customXMPNamespaces: NamespaceDefinition[],
  fields: FieldDefinition[],
  metadataDefinitions: MetadataDefinition[],
  metadataMappings: MetadataMapping[],
  selectedFieldCategory: ?string,
  selectedFieldsListItemName: ?string,
  userCatalogInfo: UserCatalogInfo[],
};

type AddCustomXMPNamespacesAction = {|
  type: 'admin/catalog/ADD_CUSTOM_XMP_NAMESPACES',
  payload: NamespaceDefinition[],
|};

type AddCustomXMPNamespacesFailAction = {|
  type: 'admin/catalog/ADD_CUSTOM_XMP_NAMESPACES_FAIL',
|};

type AddCustomXMPNamespacesSuccessAction = {|
  type: 'admin/catalog/ADD_CUSTOM_XMP_NAMESPACES_SUCCESS',
  payload: NamespaceDefinition[],
|};

type addFieldsAction = {|
  type: 'admin/catalog/ADD_FIELDS',
|};
type addFieldsFailAction = {|
  type: 'admin/catalog/ADD_FIELDS_FAIL',
|};
type addFieldsSuccessAction = {|
  type: 'admin/catalog/ADD_FIELDS_SUCCESS',
  payload: FieldDefinition[],
|};
type addOrUpdateUserCatalogInfoAction = {|
  type: 'admin/catalog/ADD_OR_UPDATE_USER_CATALOG_INFO',
|};

type addOrUpdateUserCatalogInfoFailAction = {|
  type: 'admin/catalog/ADD_OR_UPDATE_USER_CATALOG_INFO_FAIL',
|};

type addOrUpdateUserCatalogInfoSuccessAction = {|
  type: 'admin/catalog/ADD_OR_UPDATE_USER_CATALOG_INFO_SUCCESS',
|};

type CreateCatalogAction = {|
  type: 'admin/catalog/CREATE_CATALOG',
|};

type CreateCatalogFailAction = {|
  type: 'admin/catalog/CREATE_CATALOG_FAIL',
|};

type CreateCatalogSuccessAction = {|
  type: 'admin/catalog/CREATE_CATALOG_SUCCESS',
|};

type CreateCatalogTemplateAction = {|
  type: 'admin/catalog/CREATE_CATALOG_TEMPLATE',
|};

type CreateCatalogTemplateFailAction = {|
  type: 'admin/catalog/CREATE_CATALOG_TEMPLATE_FAIL',
|};

type CreateCatalogTemplateSuccessAction = {|
  type: 'admin/catalog/CREATE_CATALOG_TEMPLATE_SUCCESS',
|};

type CreateMetadataDefinitionAction = {|
  type: 'admin/catalog/CREATE_METADATA_DEFINITIONS',
|};

type CreateMetadataDefinitionFailAction = {|
  type: 'admin/catalog/CREATE_METADATA_DEFINITIONS_FAIL',
|};

type CreateMetadataDefinitionSuccessAction = {|
  type: 'admin/catalog/CREATE_METADATA_DEFINITIONS_SUCCESS',
|};

type CreateMetadataMappingsAction = {|
  type: 'admin/catalog/CREATE_METADATA_MAPPINGS',
|};

type CreateMetadataMappingsFailAction = {|
  type: 'admin/catalog/CREATE_METADATA_MAPPINGS_FAIL',
|};

type CreateMetadataMappingsSuccessAction = {|
  type: 'admin/catalog/CREATE_METADATA_MAPPINGS_SUCCESS',
|};

type DeleteCatalogAction = {|
  type: 'admin/catalog/DELETE_CATALOG',
|};

type DeleteCatalogFailAction = {|
  type: 'admin/catalog/DELETE_CATALOG_FAIL',
|};

type DeleteCatalogSuccessAction = {|
  type: 'admin/catalog/DELETE_CATALOG_SUCCESS',
|};

type DeleteCatalogTemplateAction = {|
  type: 'admin/catalog/DELETE_CATALOG_TEMPLATE',
|};

type DeleteCatalogTemplateFailAction = {|
  type: 'admin/catalog/DELETE_CATALOG_TEMPLATE_FAIL',
|};

type DeleteCatalogTemplateSuccessAction = {|
  type: 'admin/catalog/DELETE_CATALOG_TEMPLATE_SUCCESS',
|};

type DeleteMetadataDefinitionAction = {|
  type: 'admin/catalog/DELETE_METADATA_DEFINITION',
|};

type DeleteMetadataDefinitionFailAction = {|
  type: 'admin/catalog/DELETE_METADATA_DEFINITION_FAIL',
|};

type DeleteMetadataDefinitionSuccessAction = {|
  type: 'admin/catalog/DELETE_METADATA_DEFINITION_SUCCESS',
|};

type DeleteMetadataMappingsAction = {|
  type: 'admin/catalog/DELETE_METADATA_MAPPINGS',
|};

type DeleteMetadataMappingsFailAction = {|
  type: 'admin/catalog/DELETE_METADATA_MAPPINGS_FAIL',
|};

type DeleteMetadataMappingsSuccessAction = {|
  type: 'admin/catalog/DELETE_METADATA_MAPPINGS_SUCCESS',
|};

type GetCatalogsAction = {|
  type: 'admin/catalog/GET_CATALOGS',
|};

type GetCatalogsFailAction = {|
  type: 'admin/catalog/GET_CATALOGS_FAIL',
|};

type GetCatalogsSuccessAction = {|
  type: 'admin/catalog/GET_CATALOGS_SUCCESS',
  payload: Catalog[],
|};

type GetCatalogPropertiesAction = {|
  type: 'admin/catalog/GET_CATALOG_PROPERTIES',
|};

type GetCatalogPropertiesFailAction = {|
  type: 'admin/catalog/GET_CATALOG_PROPERTIES_FAIL',
|};

type GetCatalogPropertiesSuccessAction = {|
  type: 'admin/catalog/GET_CATALOG_PROPERTIES_SUCCESS',
  payload: CatalogProperties,
|};

type GetCatalogTypesAction = {|
  type: 'admin/catalog/GET_CATALOG_TYPES',
|};

type GetCatalogTypesFailAction = {|
  type: 'admin/catalog/GET_CATALOG_TYPES_FAIL',
|};

type GetCatalogTypesSuccessAction = {|
  type: 'admin/catalog/GET_CATALOG_TYPES_SUCCESS',
  payload: CatalogType[],
|};

type GetCustomXMPNamespacesAction = {|
  type: 'admin/catalog/GET_CUSTOM_XMP_NAMESPACES',
|};

type GetCustomXMPNamespacesFailAction = {|
  type: 'admin/catalog/GET_CUSTOM_XMP_NAMESPACES_FAIL',
|};

type GetCustomXMPNamespacesSuccessAction = {|
  type: 'admin/catalog/GET_CUSTOM_XMP_NAMESPACES_SUCCESS',
  payload: NamespaceDefinition[],
|};

type GetFieldsAction = {|
  type: 'admin/catalog/GET_FIELDS',
|};

type GetFieldsFailAction = {|
  type: 'admin/catalog/GET_FIELDS_FAIL',
|};

type GetFieldsSuccessAction = {|
  type: 'admin/catalog/GET_FIELDS_SUCCESS',
  payload: FieldDefinition[],
|};

type GetMetadataDefinitionsAction = {|
  type: 'admin/catalog/GET_METADATA',
|};

type GetMetadataDefinitionsFailAction = {|
  type: 'admin/catalog/GET_METADATA_FAIL',
|};

type GetMetadataDefinitionsSuccessAction = {|
  type: 'admin/catalog/GET_METADATA_SUCCESS',
  payload: MetadataDefinition[],
|};

type GetMetadataMappingsAction = {|
  type: 'admin/catalog/GET_METADATA_MAPPINGS',
|};

type GetMetadataMappingsFailAction = {|
  type: 'admin/catalog/GET_METADATA_MAPPINGS_FAIL',
|};

type GetMetadataMappingsSuccessAction = {|
  type: 'admin/catalog/GET_METADATA_MAPPINGS_SUCCESS',
  payload: MetadataMapping[],
|};

type GetUserCatalogInfoAction = {|
  type: 'admin/catalog/GET_USER_CATALOG_INFO',
|};

type GetUserCatalogInfoFailAction = {|
  type: 'admin/catalog/GET_USER_CATALOG_INFO_FAIL',
|};

type GetUserCatalogInfoSuccessAction = {|
  type: 'admin/catalog/GET_USER_CATALOG_INFO_SUCCESS',
  payload: UserCatalogInfo[],
|};

type RemoveAllPredefinedValuesAction = {|
  type: 'admin/catalog/REMOVE_ALL_PREDEFINED_VALUES',
|};

type RemoveAllPredefinedValuesFailAction = {|
  type: 'admin/catalog/REMOVE_ALL_PREDEFINED_VALUES_FAIL',
|};

type RemoveAllPredefinedValuesSuccessAction = {|
  type: 'admin/catalog/REMOVE_ALL_PREDEFINED_VALUES_SUCCESS',
|};

type RemoveCustomXmpNamespacesAction = {|
  type: 'admin/catalog/REMOVE_CUSTOM_XMP_NAMESPACES',
|};

type RemoveCustomXmpNamespacesFailAction = {|
  type: 'admin/catalog/REMOVE_CUSTOM_XMP_NAMESPACES_FAIL',
|};

type RemoveCustomXmpNamespacesSuccessAction = {|
  type: 'admin/catalog/REMOVE_CUSTOM_XMP_NAMESPACES_SUCCESS',
|};

type RemoveFieldsAction = {|
  type: 'admin/catalog/REMOVE_FIELDS',
|};

type RemoveFieldsFailAction = {|
  type: 'admin/catalog/REMOVE_FIELDS_FAIL',
|};

type RemoveFieldsSuccessAction = {|
  type: 'admin/catalog/REMOVE_FIELDS_SUCCESS',
|};

type RemoveUsersFromCatalogAction = {|
  type: 'admin/catalog/REMOVE_USERS_FROM_CATALOG',
|};

type RemoveUsersFromCatalogFailAction = {|
  type: 'admin/catalog/REMOVE_USERS_FROM_CATALOG_FAIL',
|};

type RemoveUsersFromCatalogSuccessAction = {|
  type: 'admin/catalog/REMOVE_USERS_FROM_CATALOG_SUCCESS',
|};

type RenameCatalogAction = {|
  type: 'admin/catalog/RENAME_CATALOG',
|};

type RenameCatalogFailAction = {|
  type: 'admin/catalog/RENAME_CATALOG_FAIL',
|};

type RenameCatalogSuccessAction = {|
  type: 'admin/catalog/RENAME_CATALOG_SUCCESS',
  payload: Catalog,
|};

type RenameCatalogTemplateAction = {|
  type: 'admin/catalog/RENAME_CATALOG_TEMPLATE',
|};

type RenameCatalogTemplateFailAction = {|
  type: 'admin/catalog/RENAME_CATALOG_TEMPLATE_FAIL',
|};

type RenameCatalogTemplateSuccessAction = {|
  type: 'admin/catalog/RENAME_CATALOG_TEMPLATE_SUCCESS',
  payload: Catalog,
|};

type SetIngestConfigAction = {|
  type: 'admin/catalog/SET_INGEST_CONFIG',
  payload: IngestConfig,
|};

type SetIngestConfigFailAction = {|
  type: 'admin/catalog/SET_INGEST_CONFIG_FAIL',
|};

type SetIngestConfigSuccessAction = {|
  type: 'admin/catalog/SET_INGEST_CONFIG_SUCCESS',
|};

type SetSelectedFieldCategoryAction = {|
  type: 'admin/catalog/SET_SELECTED_FIELD_CATEGORY',
  payload: string,
|};

type SetSelectedFieldsListItemNameAction = {|
  type: 'admin/catalog/SET_SELECTED_FIELDS_LIST_ITEM_NAME',
  payload: ?string,
|};

type UpdateCatalogingOptionsAction = {|
  type: 'admin/catalog/UPDATE_CATALOGING_OPTIONS',
|};

type UpdateCatalogingOptionsFailAction = {|
  type: 'admin/catalog/UPDATE_CATALOGING_OPTIONS_FAIL',
|};

type UpdateCatalogingOptionsSuccessAction = {|
  type: 'admin/catalog/UPDATE_CATALOGING_OPTIONS_SUCCESS',
|};

type UpdateDiskPreviewInfoAction = {|
  type: 'admin/catalog/UPDATE_DISK_PREVIEW_INFO',
|};

type UpdateDiskPreviewInfoFailAction = {|
  type: 'admin/catalog/UPDATE_DISK_PREVIEW_INFO_FAIL',
|};

type UpdateDiskPreviewInfoSuccessAction = {|
  type: 'admin/catalog/UPDATE_DISK_PREVIEW_INFO_SUCCESS',
|};

type UpdateFieldsAction = {|
  type: 'admin/catalog/UPDATE_FIELDS',
|};

type UpdateFieldsFailAction = {|
  type: 'admin/catalog/UPDATE_FIELDS_FAIL',
|};

type UpdateFieldsSuccessAction = {|
  type: 'admin/catalog/UPDATE_FIELDS_SUCCESS',
|};

type UpdateSmartKeywordsSettingsAction = {|
  type: 'admin/catalog/UPDATE_SMART_KEYWORDS_SETTINGS',
|};

type UpdateSmartKeywordsSettingsFailAction = {|
  type: 'admin/catalog/UPDATE_SMART_KEYWORDS_SETTINGS_FAIL',
|};

type UpdateSmartKeywordsSettingsSuccessAction = {|
  type: 'admin/catalog/UPDATE_SMART_KEYWORDS_SETTINGS_SUCCESS',
|};

export type Action =
  | AddCustomXMPNamespacesAction
  | AddCustomXMPNamespacesFailAction
  | AddCustomXMPNamespacesSuccessAction
  | addFieldsAction
  | addFieldsFailAction
  | addFieldsSuccessAction
  | addOrUpdateUserCatalogInfoAction
  | addOrUpdateUserCatalogInfoFailAction
  | addOrUpdateUserCatalogInfoSuccessAction
  | CreateCatalogAction
  | CreateCatalogFailAction
  | CreateCatalogSuccessAction
  | CreateCatalogTemplateAction
  | CreateCatalogTemplateFailAction
  | CreateCatalogTemplateSuccessAction
  | CreateMetadataDefinitionAction
  | CreateMetadataDefinitionFailAction
  | CreateMetadataDefinitionSuccessAction
  | CreateMetadataMappingsAction
  | CreateMetadataMappingsFailAction
  | CreateMetadataMappingsSuccessAction
  | DeleteCatalogAction
  | DeleteCatalogFailAction
  | DeleteCatalogSuccessAction
  | DeleteCatalogTemplateAction
  | DeleteCatalogTemplateFailAction
  | DeleteCatalogTemplateSuccessAction
  | DeleteMetadataDefinitionAction
  | DeleteMetadataDefinitionFailAction
  | DeleteMetadataDefinitionSuccessAction
  | DeleteMetadataMappingsAction
  | DeleteMetadataMappingsFailAction
  | DeleteMetadataMappingsSuccessAction
  | GetCatalogsAction
  | GetCatalogsFailAction
  | GetCatalogsSuccessAction
  | GetCatalogPropertiesAction
  | GetCatalogPropertiesFailAction
  | GetCatalogPropertiesSuccessAction
  | GetCatalogTypesAction
  | GetCatalogTypesFailAction
  | GetCatalogTypesSuccessAction
  | GetCustomXMPNamespacesAction
  | GetCustomXMPNamespacesFailAction
  | GetCustomXMPNamespacesSuccessAction
  | GetFieldsAction
  | GetFieldsFailAction
  | GetFieldsSuccessAction
  | GetMetadataDefinitionsAction
  | GetMetadataDefinitionsFailAction
  | GetMetadataDefinitionsSuccessAction
  | GetMetadataMappingsAction
  | GetMetadataMappingsFailAction
  | GetMetadataMappingsSuccessAction
  | GetUserCatalogInfoAction
  | GetUserCatalogInfoFailAction
  | GetUserCatalogInfoSuccessAction
  | RemoveAllPredefinedValuesAction
  | RemoveAllPredefinedValuesFailAction
  | RemoveAllPredefinedValuesSuccessAction
  | RemoveCustomXmpNamespacesAction
  | RemoveCustomXmpNamespacesFailAction
  | RemoveCustomXmpNamespacesSuccessAction
  | RemoveFieldsAction
  | RemoveFieldsFailAction
  | RemoveFieldsSuccessAction
  | RemoveUsersFromCatalogAction
  | RemoveUsersFromCatalogFailAction
  | RemoveUsersFromCatalogSuccessAction
  | RenameCatalogAction
  | RenameCatalogFailAction
  | RenameCatalogSuccessAction
  | RenameCatalogTemplateAction
  | RenameCatalogTemplateFailAction
  | RenameCatalogTemplateSuccessAction
  | SetIngestConfigAction
  | SetIngestConfigFailAction
  | SetIngestConfigSuccessAction
  | SetSelectedFieldCategoryAction
  | SetSelectedFieldsListItemNameAction
  | UpdateCatalogingOptionsAction
  | UpdateCatalogingOptionsFailAction
  | UpdateCatalogingOptionsSuccessAction
  | UpdateDiskPreviewInfoAction
  | UpdateDiskPreviewInfoFailAction
  | UpdateDiskPreviewInfoSuccessAction
  | UpdateFieldsAction
  | UpdateFieldsFailAction
  | UpdateFieldsSuccessAction
  | UpdateSmartKeywordsSettingsAction
  | UpdateSmartKeywordsSettingsFailAction
  | UpdateSmartKeywordsSettingsSuccessAction;



// WEBPACK FOOTER //
// ./src/state/types/catalogTypes.js